import { css } from "emotion";
import { max } from "../../utils/CssUtils";

const H3 = ({
  color = "#323232",
  marginTop = 0,
  marginBottom = 0,
  breakpoint = 600,
  maxWidth,
  marginBottomMobile = 0,
  marginTopMobile = 0,
  id,
  style = {},
  children
}) => {
  const styles = css({
    fontWeight: 600,
    fontSize: 26,
    color: color,
    marginTop: marginTop,
    marginBottom: marginBottom,
    maxWidth: maxWidth ? maxWidth : "none",
    marginLeft: maxWidth ? "auto" : "none",
    marginRight: maxWidth ? "auto" : "none",
    [max(breakpoint)]: {
      fontSize: 20,
      marginTop: marginTopMobile,
      marginBottom: marginBottomMobile
    },
    ...style
  });

  return (
    <h3 className={styles} id={id}>
      {children}
    </h3>
  );
};

export default H3;
